<template>
  <div>
    <Card class="m-b-20">
      <div class="f-22 m-b-10">免费送章申请提交成功
        <Icon type="md-checkmark" class="m-l-5 c-green" size="38"/>
      </div>
      <div class="c-gray-light f-16">您的免费送章申请已经提交成功，杭州印章网已收到并将您的订单推送至银行，请保持您的手机号畅通，客户经理会联系您预约开户时间。</div>
      <div class="c-gray-light ti_line-height-48px f-16">
        <Icon type="md-bulb" class="m-r-10 c-blue" size="28"/>
        更多流程说明请阅读下面的说明。
      </div>
    </Card>

    <Card>
      <img src="https://img.zhian.cn/sealsite-3301/6F3A6D2EE65A2A5A7846FDA1CE3020F1.jpg?x-oss-process=style/tubo_large" width="100%">
    </Card>

  </div>
</template>

<script>
  export default {
    data() {
      return {}
    },
    created() {
    }
  }
</script>
